<div class="loading-wrapper">
    <div class="loading-container" id="loading-container">

        <div class="logo">
            <img src="assets/svg/FieldEx_Black_No_Frame.svg" alt="FieldEx Logo" class="logo-img">
        </div>
        <h1 class="title">Setting things up</h1>
        <p class="subtitle">This will only take a few seconds...</p>

        <div class="lottie-overlay">
            <ng-lottie [options]="lottieOptions" width="300px" height="300px"></ng-lottie>
        </div>

        <p class="subtitle-hang-tight">Don't go anywhere</p>

        <div class="alert-banner error">
            <span class="alert-text">
                <strong>Invalid Email</strong>! It looks like you already have an existing account with FieldEx.
                Please <a href="/login" class="inline-link">log in</a> to continue,
                or use a different email address to <a href="#" class="inline-link">create a new account</a>.
                <i class="fa-solid fa-arrow-up-right-from-square icon-external"></i>
            </span>
        </div>

    </div>
</div>